import * as React from 'react'
import { forwardRef } from 'react'
import { useLogout } from 'react-admin'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import { makeStyles } from '@mui/styles'
import ExitIcon from '@mui/icons-material/PowerSettingsNew'
import { clearSession } from '@common/session'
import { useLocation } from 'react-router-dom'

const useStyles = makeStyles({
  root: {
    color: 'rgba(0, 0, 0, 0.45)',
    flexDirection: 'row-reverse',
    marginLeft: 3,
    fontSize: 16,
    fontFamily: 'Roboto, Regular',
    //   height: 48,
    //   padding: '0 30px',
  },
})

const LogoutButton = forwardRef(function LogoutButton(props, ref) {
  const classes = useStyles()
  const logout = useLogout()
  const handleClick = async () => {
    // authProvider.logout already runs clearSession; the explicit call keeps
    // this path a full teardown even if the provider changes. Idempotent.
    await logout()
    clearSession()
  }
  return (
    <MenuItem onClick={handleClick} ref={ref}>
      <Box className={classes.root}>
        <ExitIcon />
        <Box ml={5} mt={-4}>
          Logout
        </Box>
      </Box>
    </MenuItem>
  )
})

export default LogoutButton
